<div class="withdraw" [class.mobile-withdraw]="isMobileApp">

  <ng-container *ngIf="withdrawInProcess || (!withdrawInProcess && Object.keys(withdrawalAllocation).length > 0); else showLoader">
    <h1 class="ds-title-3">{{ 'ACCOUNT.reinvest.withdraw_title' | translate }}</h1>
    <form [formGroup]="withdrawalForm">
      @if (currentWdlStep === withdrawalSteps.INITIAL) {
        <app-withdrawal-init
          [accountInvested]="accountInvested"
          [withdrawalAllocation]="withdrawalAllocation"
          [currency]="currentAccount.currency"
          [isMobileApp]="isMobileApp"
          [minInvestment]="minInvestmentValue"
          [parent]="withdrawalGroup"
          [withdrawalMinBuffer]="withdrawalMinBuffer"
          (nextStep)="onNextStep($event)"
        />
      } @else if (
        currentWdlStep === withdrawalSteps.UPDATE_NOTIFICATION ||
        currentWdlStep === withdrawalSteps.IMPACT_NOTIFICATION ||
        currentWdlStep === withdrawalSteps.PROMO_NOTIFICATION
      ) {
        <app-withdrawal-notification
          [currentWdlStep]="currentWdlStep"
          [hasWithdrawalPromotion]="hasWithdrawalPromotion"
          [isMobileApp]="isMobileApp"
          [withdrawType]="withdrawalGroup.get('type').value"
          (activatePromotion)="onActivatePromotion()"
          (cancelWithdrawal)="onCancelWithdrawal($event)"
          (nextStep)="onNextStep($event)"
        />
      } @else if (currentWdlStep === withdrawalSteps.IBAN) {
        <app-withdrawal-iban
          [appLocation]="customer.app_location"
          [ibanList]="ibanList"
          [isMobileApp]="isMobileApp"
          [parent]="ibanGroup"
          (ibanCheck)="onIbanCheck($event)"
          (prevStep)="onPrevStep()"
          (nextStep)="onNextStep($event)"
        />
      } @else if (currentWdlStep === withdrawalSteps.REASONS) {
        <app-withdrawal-reasons
          [isMobileApp]="isMobileApp"
          [reasonOptions]="reasons?.survey_answer_options"
          [parent]="extraGroup"
          [withdrawalType]="withdrawalGroup.get('type').value"
          (prevStep)="onPrevStep()"
          (nextStep)="onNextStep($event)"
        />
      } @else if (currentWdlStep === withdrawalSteps.CLOSE) {
        <app-withdrawal-close [isMobileApp]="isMobileApp" [parent]="extraGroup" (prevStep)="onPrevStep()" (nextStep)="onNextStep($event)" />
      } @else if (currentWdlStep === withdrawalSteps.SUMMARY) {
        <app-withdrawal-summary
          [accountInvested]="accountInvested"
          [currency]="currentAccount.currency"
          [isMobileApp]="isMobileApp"
          [ibanList]="ibanList"
          [minInvestment]="minInvestmentValue"
          [totalAmount]="withdrawalAllocation?.totalAmount"
          [withdrawForm]="withdrawalForm.value"
          [withdrawalMinBuffer]="withdrawalMinBuffer"
          (openStep)="onOpenStep($event)"
          (prevStep)="onPrevStep()"
          [isLoading]="isLoading"
          (submitRequest)="onSubmitRequest()"
        />
      } @else if (currentWdlStep === withdrawalSteps.STATUS) {
        <app-withdrawal-status
          [isMobileApp]="isMobileApp"
          [keepAccount]="extraGroup.get('keepAccount').value"
          [withdrawalStatus]="withdrawalStatus"
          [withdrawalType]="withdrawalGroup.get('type').value"
          (openProfile)="onOpenProfile()"
        />
      }
    </form>
  </ng-container>

  <ng-template #showLoader>
    <ng-container *ngIf="isMobileApp; else webLoader">
      <h1 class="ds-title-3">
        <ion-skeleton-text animated style="width: 165px; height: 32px"></ion-skeleton-text>
      </h1>
      <p class="ds-heading-2">
        <ion-skeleton-text animated style="width: 100%; height: 20px; margin-bottom: 12px"></ion-skeleton-text>
      </p>
      <div class="ds-heading-2">
        <ion-skeleton-text animated style="width: 100%; height: 24px; margin-bottom: 12px"></ion-skeleton-text>
      </div>
      <div class="ds-heading-2">
        <ion-skeleton-text animated style="width: 100%; height: 16px; margin-bottom: 8px"></ion-skeleton-text>
      </div>
      <div class="ds-heading-2">
        <ion-skeleton-text animated style="width: 100%; height: 16px; margin-bottom: 8px"></ion-skeleton-text>
      </div>
      <div class="ds-heading-2">
        <ion-skeleton-text animated style="width: 100%; height: 16px; margin-bottom: 8px"></ion-skeleton-text>
      </div>
    </ng-container>

    <ng-template #webLoader>
      <div class="skeleton-wrapper">
        <div class="skeleton withdrawal-header"></div>
        <div class="withdrawal-subheader">
          <div class="skeleton"></div>
          <div class="skeleton"></div>
        </div>
        <div class="skeleton withdrawal-bar"></div>
        <div class="withdrawal-allocation">
          <div class="skeleton"></div>
          <div class="skeleton"></div>
        </div>
        <div class="withdrawal-allocation">
          <div class="skeleton"></div>
          <div class="skeleton"></div>
        </div>
        <div class="withdrawal-allocation">
          <div class="skeleton"></div>
          <div class="skeleton"></div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
